let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hJxYB")).then(() => parcelRequire('hV2Rc'));